import { Key } from 'react-aria'
import { createContextWithHook } from '@chilipiper/utils'
import { ItemData } from './itemData.types'

const { useSelectItemContext, SelectItemBaseProvider } =
  createContextWithHook<Record<Key, ItemData>>()('SelectItem')

export const SelectItemDataProvider = SelectItemBaseProvider
export const useSelectItemData = (key: Key) => {
  const data = useSelectItemContext()
  const itemData = data[key]
  if (!itemData) {
    throw new Error(`No data found for key ${key}`)
  }
  return itemData
}

export const useSelectItemsData = useSelectItemContext
